'use client';

import SkeletonProductSlider from '@modules/skeletons/components/skeleton-product-slider';
import * as Sentry from '@sentry/nextjs';
import { useEffect, useState } from 'react';
import ProductSlider from '.';
import { getSliderProducts } from './actions';

type SliderProducts = Awaited<ReturnType<typeof getSliderProducts>>;

export default function ProductSliderSection() {
  const [products, setProducts] = useState<SliderProducts | null>(null);

  useEffect(() => {
    let cancelled = false;

    getSliderProducts()
      .then((result) => {
        if (!cancelled) {
          setProducts(result);
        }
      })
      .catch((error) => {
        if (cancelled) {
          return;
        }
        Sentry.captureException(error, {
          extra: { context: 'ProductSliderSection:getSliderProducts' },
        });
        setProducts([]);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  if (products === null) {
    return <SkeletonProductSlider />;
  }

  if (products.length === 0) {
    return null;
  }

  return (
    <ProductSlider
      title="Explore Our Most Popular Treatments"
      description="Find the right treatment for you."
      overline={null}
      products={products}
      ctas={null}
    />
  );
}
